import { NavLink } from "react-router-dom";

const STEPS = [
  { to: "/beta", label: "Invitation", end: true },
  { to: "/beta/agreement", label: "Agreement" },
  { to: "/beta/profile", label: "Profile" },
];

export default function BetaLayout({ children }) {
  return (
    <div className="beta-frame">
      <aside className="beta-rail" aria-label="Beta steps">
        <p className="beta-rail__kicker">Private access</p>
        <p className="beta-rail__title">REChecklist Beta</p>
        <ol className="beta-rail__steps">
          {STEPS.map((step, index) => (
            <li key={step.to}>
              <NavLink
                to={step.to}
                end={Boolean(step.end)}
                className={({ isActive }) => `beta-rail__link${isActive ? " is-active" : ""}`}
              >
                <span className="beta-rail__num">{index + 1}</span>
                {step.label}
              </NavLink>
            </li>
          ))}
        </ol>
        <p className="beta-rail__note">Confidential early access. One invited desk.</p>
      </aside>
      <div className="beta-stage">{children}</div>
    </div>
  );
}
